import { ProductType } from '../../__generated__/graphql';

export interface ProductTypeOption {
  label: string;
  value: ProductType;
}

export const PRODUCT_TYPE_OPTIONS: ProductTypeOption[] = [
  { label: 'All Types', value: ProductType.All },
  { label: 'Car', value: ProductType.Car },
  { label: 'Room', value: ProductType.Room },
  { label: 'House', value: ProductType.House },
  { label: 'Catering', value: ProductType.Catering },
  { label: 'Furniture', value: ProductType.Furniture },
  { label: 'Sports Item', value: ProductType.Sports },
  { label: 'Pickleball Gear', value: ProductType.Pickleball },
  { label: 'Tennis Gear', value: ProductType.Tennis },
  { label: 'Snowboarding Gear', value: ProductType.Snowboarding },
  { label: 'House Remodeling', value: ProductType.HouseRemodeling },
  { label: 'Home Improvement', value: ProductType.HomeImprovement },
  { label: 'Coaching Service', value: ProductType.Coaching },
  { label: 'Other', value: ProductType.Other },
];

export const DEFAULT_PRODUCT_TYPE = ProductType.Car;

export const getProductTypeLabel = (type?: ProductType) =>
  PRODUCT_TYPE_OPTIONS.find(option => option.value === type)?.label ?? 'All Types';
